
<div class="input-container">
  <input id="dateRangePicker" class="dateRangePickerField" type="text"
    ngxDaterangepickerMd
    [(ngModel)]="selected"
    [showCustomRangeLabel]="true"
    [alwaysShowCalendars]="true"
    [ranges]="ranges"
    [linkedCalendars]="true"
    [showClearButton]="true"
    [maxDate]="maxDate"
    autocomplete="off"
    [locale]="locale"
    (ngModelChange)="onSelectedChange($event)"
    placeholder = {{configData?.placeHolder}}/>
    <label for="dateRangePicker" class="field-icon">
      <span class="icon-mask"></span>
    </label>
</div>


        